module.exports = __webpack_public_path__ + "img/undraw_coding_6mjf.019765f5.svg";